var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notificazion animate__animated",class:[
    _vm.alert2?.type == 'success' ? 'alert-success' : 'alert-error',
    _vm.alert2?.status === true && 'bounceInLeft animate__bounceInRight',
  ],on:{"click":_vm.closeAlert}},[_c('span',{staticClass:"alert_message_box"},[_vm._v(_vm._s(_vm.alert2?.message))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"closebtn"},[_c('i',{staticClass:"fa fa-times"})])
}]

export { render, staticRenderFns }